module.exports = __webpack_public_path__ + "img/selected0-min.ad6789b3.png";